// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"5881":"9e4179e7","8847":"7b672fd0","9807":"bbba4147"}[chunkId] + ".css";
};